var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 23.8333L10.6167 23.8333C14.0833 23.8333 16.25 21.6666 16.25 18.2L16.25 13.8125L9.47917 13.8125C9.035 13.8125 8.66667 13.4441 8.66667 13C8.66667 12.5558 9.035 12.1875 9.47917 12.1875L16.25 12.1875L16.25 7.79998C16.25 4.33332 14.0833 2.16665 10.6167 2.16665L7.81083 2.16665C4.34417 2.16665 2.1775 4.33331 2.1775 7.79998L2.1775 18.2C2.16667 21.6666 4.33333 23.8333 7.8 23.8333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0575 13.8125L18.815 16.055C18.6525 16.2175 18.5767 16.4233 18.5767 16.6292C18.5767 16.835 18.6525 17.0517 18.815 17.2033C19.1292 17.5175 19.6492 17.5175 19.9633 17.2033L23.5925 13.5742C23.9067 13.26 23.9067 12.74 23.5925 12.4258L19.9633 8.79667C19.6492 8.48251 19.1292 8.48251 18.815 8.79667C18.5008 9.11084 18.5008 9.63084 18.815 9.94501L21.0575 12.1875L16.2475 12.1875L16.2475 13.8125L21.0575 13.8125V13.8125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.66ec8bc2ee6cdeaecd0d9493cca54c28.svg";
export { ForwardRef as ReactComponent };